import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const ControlRoute = ({ children }) => {
	const role = useSelector((state) => state.user.authUser?.userType)

	if (role === undefined) return null

	return role === 'superAdmin' ? children : <Navigate to='/' replace />
}

export default ControlRoute
